<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
    <v-container fluid full-height grid-list-md>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm4>
                <v-text-field
                  name="shopCode"
                  label="Shop Code"
                  type="text"
                  @click="showShop"
                  v-model="queryParams.shopCode"
                  :rules="[(v) => !!v || 'Shop Code is required.']"
                ></v-text-field>
              </v-flex>
              <v-flex sm4>
                <v-select
                  v-model="queryParams.financeSettingId"
                  :items="financeSettingList"
                  color="blue-grey lighten-2"
                  label="Choose Finance Setting..."
                  item-text="financialYearName"
                  menu-props="auto"
                  item-value="id"
                  @input="bindMonth(queryParams.financeSettingId)"
                ></v-select>
              </v-flex>
              <v-flex sm4>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="queryParams.yearAndMonth"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="queryParams.yearAndMonth"
                      label="Balance Month"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="queryParams.yearAndMonth"
                    type="month"
                    no-title
                    scrollable
                    :min="minMonth"
                    :max="maxMonth"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="menu = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      flat
                      color="primary"
                      @click="$refs.menu.save(queryParams.yearAndMonth)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm4>
                <v-radio-group
                  v-model="queryParams.trialBalanceType"
                  :mandatory="false"
                  row
                >
                  <v-radio label="All" value="ALL"></v-radio>
                  <v-radio label="With Balance" value="WITHBALANCE"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex sm4>
                <v-btn outline color="primary" @click="onSearch">Preview</v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12 class="mt-1">
          <v-card>
            <v-flex xs12 ml-2 pt-4>
              <div style="float: left; padding-left: 15px">
                <h3 style="margin: 0px; color: blue" id="counter">
                  Trial Balance
                </h3>
              </div>
            </v-flex>
            <v-flex xs12 ml-2 pt-4>
              <div style="float: left; padding-left: 11px">
                <p
                  style="font-size: 13px; margin: 0px; font-weight: bold"
                  id="counter"
                >
                  Shop Code : {{ shopCode }}
                </p>
              </div>
            </v-flex>
            <v-flex xs12 ml-2 pt-4>
              <div style="float: left; padding-left: 11px">
                <p
                  style="font-size: 13px; margin: 0px; font-weight: bold"
                  id="counter"
                >
                  For {{ fromDate }} - {{ toDate }}
                </p>
              </div>
            </v-flex>
            <v-flex xs12 ml-2 pt-4>
              <div style="float: left; padding-left: 11px">
                <h4 style="margin: 0px; color: blue" id="counter">
                  Summary Of Active Accounts
                </h4>
              </div>
            </v-flex>
            <v-flex xs12 ml-2 pt-4>
              <div
                style="width: 100%; height: 3px; background-color: blue"
              ></div>
            </v-flex>
            <v-data-table
              :headers="headers"
              :items="trialBalanceDetailList"
              class="elevation-1"
              :loading="showListLoading"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <tr
                  v-if="
                   (queryParams.trialBalanceType == 'WITHBALANCE'
                      ? props.item.debitAmount > 0 ||
                        props.item.creditAmount > 0 
                      : true
                  ) && !props.item.chartOfAccount.isHide"
                >
                  <td>{{ props.item.chartOfAccount.code }}</td>
                  <td>{{ props.item.chartOfAccount.accName }}</td>
                  <td>
                    {{ props.item.chartOfAccount.accounthead.accountName }}
                  </td>
                  <td
                    style="
                      width: calc(100% / 7);
                      overflow: hidden;
                      text-align: right;
                    "
                    class="text-xs"
                  >
                   <span v-if="props.item.chartOfAccount.nature =='DR' && props.item.chartOfAccount.carryOn && props.item.chartOfAccount.previousTrial">
                      {{ props.item.openingBalance + props.item.journalAmount | decFormat(6) }} </span>
                   <span v-else-if="props.item.chartOfAccount.nature =='DR'">
                      {{ props.item.closingBalance | decFormat(6) }} </span>
                  </td>
                  <td
                    style="
                      width: calc(100% / 7);
                      overflow: hidden;
                      text-align: right;
                    "
                    class="text-xs"
                  >
                    <span v-if="props.item.chartOfAccount.nature =='CR' && props.item.chartOfAccount.carryOn && props.item.chartOfAccount.previousTrial">
                      {{ props.item.openingBalance + props.item.journalAmount | decFormat(6) }} </span>
                    <span v-else-if="props.item.chartOfAccount.nature =='CR'">
                      {{ props.item.closingBalance | decFormat(6) }} </span>  
                  </td>
                </tr>
              </template>
              <template slot="footer">
                <td colspan="3">Total</td>
                <td style="text-align: right;">{{ totalDebitAmount | decFormat(6) }}</td>
                <td style="text-align: right;">{{ totalCreditAmount | decFormat(6) }}</td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex> 

        <v-flex sm12>
          <div class="text-xs-center">
            <v-btn color="error" @click="clear">
              Reset
              <v-icon right>clear</v-icon>
            </v-btn>
            <v-btn color="primary" :loading="saveLoading" @click="onSave">
              Save
              <v-icon right>save</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>

      <!-- Shop list dialog -->
      <v-dialog v-model="showShopListDialog" scrollable max-width="1000px">
        <v-card>
          <v-card-title>
            <!-- Search Section -->
            <v-layout wrap>
              <v-flex sm3 pl-1>
                <v-text-field
                  name="name"
                  label="Shop Name"
                  type="text"
                  v-model="shopParams.name"
                ></v-text-field>
              </v-flex>
              <v-flex sm3 pl-1>
                <v-text-field
                  name="code"
                  label="Shop Code"
                  type="text"
                  v-model="shopParams.code"
                ></v-text-field>
              </v-flex>
              <v-flex sm2>
                <v-btn outline color="primary" @click="searchShop">
                  Search
                  <v-icon right>search</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <!-- Shop List Section -->
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="shopheaders"
                  :items="shopList"
                  class="elevation-1"
                  :loading="showListLoading"
                  :total-items="totalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :must-sort="true"
                >
                  <template slot="items" slot-scope="props">
                    <td
                      @click="
                        setShop(props.item.code),
                          (showShopListDialog = !showShopListDialog)
                      "
                    >
                      <a>{{ props.item.code }}</a>
                    </td>
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.warehouseName }}</td>
                    <td>{{ props.item.binName }}</td>
                    <td>{{ props.item.regionName }}</td>
                    <td>{{ props.item.address }}</td>
                    <td>{{ props.item.township.name }}</td>
                    <td>{{ props.item.city.name }}</td>
                    <td>{{ props.item.phoneNo }}</td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- End dialog -->

      <!-- Trial print hidden area -->
      <!-- <trial id="trialPrint"></invoice> -->
      <div
        id="trialPrint"
        style="bsale: 1px solid black; width: 300px"
        v-show="false"
      >
        <div style="text-align: center; padding-bottom: 5px">
          <p style="font-size: 15px; margin: 0px; font-weight: bold">
            Trial Balance
          </p>
        </div>

        <div style="text-align: center">
          <p style="font-size: 11px; margin: 0px"></p>
        </div>
        <div style="float: left; padding-left: 11px">
          <p style="font-size: 13px; margin: 0px" id="counter">
            Trial Balance Code : {{ trialBalance.code }}
          </p>
        </div>
        <div style="float: right; padding-right: 11px">
          <p style="font-size: 13px; margin: 0px" id="counter">
            Account Type : {{ trialBalance.trialBalanceType }}
          </p>
        </div>
        <br />
        <div style="float: left; padding-left: 11px">
          <p style="font-size: 13px; margin: 0px" id="counter">
            Shop Code: {{ trialBalance.shopCode }}
          </p>
        </div>
        <div style="float: right; padding-right: 11px">
          <p style="font-size: 13px; margin: 0px" id="counter">
            Created Date :
            {{
              trialBalance.createdDateInMilliSeconds
                | format-ms-date-time
            }}
          </p>
        </div>
        <br />
        <div style="float: left; padding-left: 11px">
          <p style="font-size: 13px; margin: 0px" id="casher">
            Balance Month: {{ trialBalance.month }} {{ trialBalance.year }}
          </p>
        </div>
        <div style="float: right; padding-right: 11px">
          <p style="font-size: 13px; margin: 0px" id="counter">
            Created By : {{ trialBalance.createdBy }}
          </p>
        </div>
        <br />
        <div style="float: left; padding-left: 11px; padding-top: 5px">
          <p
            style="font-size: 13px; margin: 0px; font-weight: bold"
            id="casher"
          >
            Summary Of Active Accounts
          </p>
        </div>
        <div style="clear: both"></div>
        <div style="height: 10px"></div>
        <div style="padding-left: 5px; padding-right: 5px">
          <table
            style="
              font-family: arial, sans-serif;
              border-collapse: collapse;
              width: 100%;
              font-size: 11px;
            "
          >
            <thead
              style="
                border-bottom: 1px solid black;
                border-top: 1px solid black;
              "
            >
              <tr style="line-height: 20px;">
                <th style="border: 1px solid black; text-align: center">
                  Account Code
                </th>
                <th style="border: 1px solid black; text-align: center">
                  Account Name
                </th>
                <th style="border: 1px solid black; text-align: center">
                  Account Head
                </th>
                <th style="border: 1px solid black; text-align: center">
                  Debit
                </th>
                <th style="border: 1px solid black; text-align: center">
                  Credit
                </th>
              </tr>
            </thead>
            <tbody v-for="(item, index) in trialBalance.trialBalanceDetailList"
                :key="index">
              <tr v-if="
                   (queryParams.trialBalanceType == 'WITHBALANCE'
                      ? item.debitAmount > 0 ||
                        item.creditAmount > 0 
                      : true
                  ) && !item.chartOfAccount.isHide"
                 style="line-height: 20px;"
              >
                <td style="border: 1px solid black; text-align: center">
                  <span>{{ item.chartOfAccount.code }}</span>
                </td>
                <td style="border: 1px solid black; text-align: left">
                  <span>{{ item.chartOfAccount.accName }}</span>
                </td>
                <td style="border: 1px solid black; text-align: left">
                  {{ item.chartOfAccount.accounthead.accountName }}
                </td>
                <td style="border: 1px solid black; text-align: right">
                  <span v-if="item.chartOfAccount.nature =='DR' && item.chartOfAccount.carryOn && item.chartOfAccount.previousTrial">
                      {{ item.openingBalance + item.journalAmount | decFormat(6) }} </span>
                   <span v-else-if="item.chartOfAccount.nature =='DR'">
                      {{ item.closingBalance | decFormat(6) }} </span>
                </td>
                <td style="border: 1px solid black; text-align: right">
                  <span v-if="item.chartOfAccount.nature =='CR' && item.chartOfAccount.carryOn && item.chartOfAccount.previousTrial">
                      {{ item.openingBalance + item.journalAmount | decFormat(6) }} </span>
                    <span v-else-if="item.chartOfAccount.nature =='CR'">
                      {{ item.closingBalance | decFormat(6) }} </span> 
                </td>
              </tr>
              </tbody>
              <tr style="line-height: 20px;">
                <td colspan="3" style="border: 1px solid black">Total</td>
                <td style="border: 1px solid black; text-align: right">
                  {{ totalDebitAmount | decFormat(6) }}
                </td>
                <td style="border: 1px solid black; text-align: right">
                  {{ totalCreditAmount | decFormat(6) }}
                </td>
              </tr>
          </table>
          <div style="height: 10px"></div>
        </div>
      </div>
      <!-- End print  -->
    </v-container>
  </v-form>
</template>
<script>
import { trialBalanceService } from "../../services/trial-balance-service";
import { shopService } from "../../services/shop-service";
import { TrialBalance } from "../../models/model";
import { commonService } from "../../services/common-service";
import { financeSettingService } from "../../services/finance-setting-service";
export default {
  name: "TrialBalanceList",
  components: {},
  data: () => ({
    breadcrumbs: [
      {
        text: "Trial Balance",
        disabled: true,
      },
      {
        text: "Trial Balance Detail",
        disabled: true,
      },
    ],
    valid: true,
    showListLoading: false,
    showShopListDialog: false,
    saveLoading: false,
    menu: false,
    responseError: "",
    shopCode: "",
    financeSettingId: "",
    yearAndMonthInMilliSeconds: "",
    decimalFormat: "",
    fromDate: "",
    toDate: "",
    minMonth: "",
    maxMonth: "",
    shopList: [],
    financeSettingList: [],
    trialBalanceDetailList: [],
    trialBalance: new TrialBalance(),
    totalDebitAmount: 0,
    totalCreditAmount: 0,
    totalDifferentAmount: 0,
    selectedIndex: 0,
    totalRows: 0,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "name",
      totalItems: 0,
    },
    rowsPerPageItems: [25, 50, 100],
    shopParams: {
      name: "",
      code: "",
    },
    queryParams: {
      financeSettingId: "",
      shopCode: "",
      trialBalanceType: "ALL",
      yearAndMonth: new Date().toISOString().substr(0, 7),
    },
    shopheaders: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Warehouse", align: "left", value: "warehouseName" },
      { text: "Bin", align: "left", value: "binName" },
      { text: "Region", value: "region" },
      { text: "Address", value: "address" },
      { text: "Township", value: "township" },
      { text: "City", value: "city" },
      { text: "Phone No", value: "phoneNo" },
    ],
    headers: [
      { text: "Account Code", value: "accountParent.code", sortable: false },
      { text: "Account Name", value: "accountParent.accName", sortable: false },
      { text: "Account Head", value: "accounthead", sortable: false },
      { text: "Debit", value: "debit", align: "center", sortable: false},
      { text: "Credit", value: "credit", align: "center", sortable: false },
    ],
  }),
  watch: {
    pagination: {
      handler() {
        this.getShopList();
      },
      deep: true,
    },
  },
  created() {
    this.getFinanceSettingList();
    //for deep linking
    const id = this.$route.params.id;
    if (id == "new") {
      // new trial balance
    }
    this.decimalFormat = commonService.formatdecimal();
  },
  methods: {
    onSearch() {
      if (this.queryParams.shopCode) {
        this.getTrialBalanceDetailList();
        this.shopCode = this.queryParams.shopCode;

        this.yearAndMonthInMilliSeconds = commonService.convertToMilliseconds(
          this.queryParams.yearAndMonth
        );
        if (this.queryParams.financeSettingId) {
          this.financeSettingId = this.queryParams.financeSettingId;
        }
        this.fromDate = commonService.millisecondToDate(
          parseInt(this.yearAndMonthInMilliSeconds),
          "YYYY-MM-DD"
        );
        let startDate = new Date(this.fromDate);
        let endDate = new Date(
          startDate.getFullYear(),
          startDate.getMonth() + 1,
          0
        );
        this.fromDate = commonService.formatDate(startDate, "MMMM DD YYYY");
        this.toDate = commonService.formatDate(endDate, "MMMM DD YYYY");
      } else {
        this.responseError = "Shop Code is required.";
      }
    },
    onSave() {
      this.saveLoading = true;
      this.trialBalance.shopCode = this.shopCode;
      this.trialBalance.financeSettingId = this.financeSettingId;
      this.trialBalance.trialBalanceType = this.queryParams.trialBalanceType;
      this.trialBalance.yearAndMonth = this.queryParams.yearAndMonth;
      this.trialBalance.yearAndMonthInMilliSeconds = parseInt(
        this.yearAndMonthInMilliSeconds
      );
      this.trialBalance.trialBalanceDetailList = this.trialBalanceDetailList;
      trialBalanceService
        .saveTrialBalance(this.trialBalance)
        .then((res) => {
          console.log(res);
          this.trialBalance.code = res.data.trialBalance.code;
          this.trialBalance.month = res.data.trialBalance.month;
          this.trialBalance.year = res.data.trialBalance.year;
          this.trialBalance.createdBy = res.data.trialBalance.createdBy;
          this.trialBalance.createdDateInMilliSeconds =
            res.data.trialBalance.createdDateInMilliSeconds;
          this.saveLoading = false;
        })
        .then(() => {
          this.printInvoice("trialPrint");
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
          this.saveLoading = false;
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    getTrialBalanceDetailList() {
      this.showListLoading = true;
      trialBalanceService
        .getTrialBalanceDetailFromLedger(this.queryParams)
        .then((res) => {
          this.trialBalanceDetailList = res.data.trialBalanceDetailList;
          this.totalDebitAmount = res.data.totalDebitAmount;
          this.totalCreditAmount = res.data.totalCreditAmount;
          this.totalDifferentAmount = res.data.totalDifferentAmount;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    searchShop() {
      this.shopParams.page = this.pagination.page;
      this.shopParams.size = this.pagination.rowsPerPage;
      this.getShopList();
    },
    showShop() {
      // Clean query params
      this.shopParams.code = "";
      this.shopParams.name = "";
      this.getShopList().then(
        (this.showShopListDialog = !this.showShopListDialog)
      );
    },
    setShop(code) {
      this.queryParams.shopCode = code;
    },
    getShopList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return shopService
        .getShopList(
          this.shopParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.shopList = res.data.shopList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      this.queryParams.shopCode = "";
      this.trialBalance = new TrialBalance();
      this.shopCode = "";
      this.trialBalanceDetailList = [];
      this.fromDate = "";
      this.toDate = "";
      this.responseError = "";
      this.totalDebitAmount = 0;
      this.totalCreditAmount = 0;
      this.totalDifferentAmount = 0;
    },
    goBack() {
      this.$router.push("/trial-balances");
    },
    printInvoice(divName) {
      var printContents = document.getElementById(divName).innerHTML;

      // var originalContents = document.body.innerHTML;
      var myWindow = window.open("", "MsgWindow", "width=350,height=500");
      myWindow.document.write(printContents);

      // document.body.innerHTML = printContents;
      myWindow.print();

      // document.body.innerHTML = originalContents;
      myWindow.close();

      // clear previous cart item
      this.clear();
    },
    getFinanceSettingList() {
      financeSettingService
        .getAllFinanceSetting()
        .then((res) => {
          this.financeSettingList = res.data.financeSettingDTOs;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.response = err.response.data.message;
          }
        });
    },
    bindMonth(id) {
      let financeSetting = commonService.search(
        "id",
        id,
        this.financeSettingList
      );
      this.minMonth = financeSetting.startMonth;
      this.maxMonth = financeSetting.endMonth;
      this.queryParams.yearAndMonth = financeSetting.startMonth;
    },
  },
};
</script>
